// extracted by mini-css-extract-plugin
export default {"portrait":"Board_portrait__1otbR","sideSeparator":"Board_sideSeparator__uDTzy","shrink":"Board_shrink__dqe2E"};